<template>
  <div>
    <Toolbar :handle-delete="del">
      <template slot="left">
        <v-toolbar-title v-if="item">{{
          `${$options.servicePrefix} ${item['@id']}`
        }}</v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-localisation-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>Field</th>
              <th>Value</th>

              <th>Field</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('nom') }}</strong></td>
              <td>
                                    {{ item['nom'] }}
              </td>
            
              <td><strong>{{ $t('site') }}</strong></td>
              <td>
                                    {{ item['site'].name }}
              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('salle') }}</strong></td>
              <td>
                                    {{ item['salle'] }}
              </td>
            
              <td><strong>{{ $t('etage') }}</strong></td>
              <td>
                                    {{ item['etage'] }}
              </td>
            </tr>
            
            <tr>
              <td><strong>{{ $t('batiment') }}</strong></td>
              <td>
                                    {{ item['batiment'] }}
              </td>
            
              <td><strong>{{ $t('visible') }}</strong></td>
              <td>
                                    {{ item['visible'] }}
              </td>
            </tr>
            
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'Localisation';

export default {
  name: 'LocalisationShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin],
  computed: {
    ...mapFields('localisation', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('localisation', ['find'])
  },
  methods: {
    ...mapActions('localisation', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
